// ABOUTME: Contextual push-permission nudge (#2567) — replaces the old
// "register the moment the user is authenticated" behaviour (effectively
// at launch) with a prompt fired only after a qualifying in-app event (the
// agent surfacing an approval, or finishing a run). Shown at most once per
// install via a persisted flag, same shape as push.ts's own once-per-install
// OS-prompt guard.

import { isNativePlatform } from './detection'
import { registerForPush } from './push'

const CONTEXTUAL_OFFERED_KEY = 'maxflow.push.contextual_offered'

function hasOfferedContextualPush(): boolean {
  try {
    return globalThis.localStorage?.getItem(CONTEXTUAL_OFFERED_KEY) === '1'
  } catch {
    return false
  }
}

function markContextualPushOffered(): void {
  try {
    globalThis.localStorage?.setItem(CONTEXTUAL_OFFERED_KEY, '1')
  } catch {
    // localStorage unavailable — best-effort only, worst case we offer again.
  }
}

/**
 * Whether a qualifying in-app event (an approval card shown, a run
 * completing) should surface the contextual push-permission nudge right now.
 * Marks the offer as made immediately, so this is a one-shot check — call it
 * only from the site that will actually show the nudge on a `true` result.
 */
export function offerContextualPush(): boolean {
  if (!isNativePlatform() || hasOfferedContextualPush()) return false
  markContextualPushOffered()
  return true
}

/** The user tapped "Enable" on the contextual nudge. */
export function acceptContextualPush() {
  return registerForPush()
}
